/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Unit testy.
/**
 * Továrna na zdroje funkcionalit v podobě HTML iframe elementů.
 * @implements {ViewerSourceFactory}
 */
class ViewerSourceIframeFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ViewerSourceIframe>} ViewerSourceIframe Konstruktor zdroje iframe elementu.
   * @param {ViewerFrameFactory} frameFactory
   * @returns {ViewerSourceIframeFactory} Nová instance.
   */
  constructor(ViewerSourceIframe, frameFactory) {
    this.ViewerSourceIframe = ViewerSourceIframe;
    this.frameFactory = frameFactory;
    this.parentEl = null;
  }

  /** @inheritdoc */
  create() {
    return new this.ViewerSourceIframe(this.frameFactory, this.parentEl);
  }

  /** @inheritdoc */
  delete(source) {
    return source.destroy();
  }

  /** @inheritdoc */
  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }
}

export default ViewerSourceIframeFactory;
